import { isConfigFlagEnabled } from '../config';
/**
 * Contains a subset of setting types from the server that are supported by this client.
 * These values are the `db_name` field on a corresponding `PokerPlayerOption.java` class instance.
 */
export const PLAYER_SERVER_SETTING_TYPES = [
    'four_color_deck',
    'auto_reload_buyin',
    'sidebets_enabled',
    'show_chips_as_bb_multiple',
    'animated_room_backgrounds',
    'email_notifications'
];
export function isSupportedPlayerServerSettingType(str) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return PLAYER_SERVER_SETTING_TYPES.includes(str);
}
export const PLAYER_SERVER_SETTING_PROPERTIES = {
    four_color_deck: {
        name: 'Four-Color Deck',
        description: 'Each suit has a unique color, making it easier to see certain kinds of hands.',
        isPowerPlayerOnly: true,
        showInSettingsModal: true
    },
    auto_reload_buyin: {
        name: 'Auto Reload Chips',
        description: "When playing in a regular game with 'Auto Reload Chips' enabled (as a room setting as well as your setting), losing all your chips will not kick you out of the seat. Instead, you will automatically and immediately reload chips from your bank if possible, without missing the next hand.",
        isPowerPlayerOnly: true,
        showInSettingsModal: true
    },
    sidebets_enabled: {
        name: 'Side Betting',
        description: 'Enables side-betting Jacks on the player you think will win the current hand.',
        isPowerPlayerOnly: false,
        isDisabled: !isConfigFlagEnabled('sideBets'),
        gameGuidePageType: 'side-bets',
        showInSettingsModal: true
    },
    show_chips_as_bb_multiple: {
        name: 'Show Chips as Big Blind Multiple',
        description: 'For chips that are in play, show amounts as multiples of the big blind rather than chips.',
        isPowerPlayerOnly: true,
        isDisabled: !isConfigFlagEnabled('showChipsAsBbMultipleAvailable'),
        showInSettingsModal: true
    },
    animated_room_backgrounds: {
        name: 'Animated Room Backgrounds',
        description: 'Moves the background behind the poker table in a subtle way.',
        isPowerPlayerOnly: true,
        isDisabled: !isConfigFlagEnabled('animatedRoomBackgroundsAvailable'),
        showInSettingsModal: false
    },
    email_notifications: {
        name: 'Email Notifications',
        description: 'Whether you will receive email notifications such as private messages and newsletters.',
        isPowerPlayerOnly: false,
        showInSettingsModal: true
    }
};
